/**
 * 管理者ページのルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import Login from '../views/admin/Login.vue'
import StudyManagement from '../views/admin/StudyManagement.vue'
import StudyManagementDetail from '../views/admin/StudyManagementDetail.vue'
import StudyManagementCandidate from '../views/admin/StudyManagementCandidate.vue'
import AcademyManagement from '../views/admin/AcademyManagement.vue'
import BranchManagement from '../views/admin/BranchManagement.vue'
import TeacherManagement from '../views/admin/TeacherManagement.vue'
import StudentManagement from '../views/admin/StudentManagement.vue'
import NotificationManagement from '../views/admin/NotificationManagement.vue'
import BatchUpdate from '../views/admin/BatchUpdate.vue'

/**
 * 管理者側ページ群
 *   nameに接頭辞'Admin'を付ける
 */
const adminRoutes: Array<RouteConfig> = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: Login,
  },
  {
    path: '/admin/study-management',
    name: 'AdminStudyManagement',
    component: StudyManagement,
  },
  {
    path: '/admin/study-management-detail/:studyId',
    name: 'AdminStudyManagementDetail',
    component: StudyManagementDetail,
  },
  {
    path: '/admin/study-management-candidate/:studyId',
    name: 'AdminStudyManagementCandidate',
    component: StudyManagementCandidate,
  },
  {
    path: '/admin/academy-management',
    name: 'AdminAcademyManagement',
    component: AcademyManagement,
  },
  {
    path: '/admin/branch-management',
    name: 'AdminBranchManagement',
    component: BranchManagement,
  },
  {
    path: '/admin/teacher-management',
    name: 'AdminTeacherManagement',
    component: TeacherManagement,
  },
  {
    path: '/admin/student-management',
    name: 'AdminStudentManagement',
    component: StudentManagement,
  },
  {
    path: '/admin/notification-management',
    name: 'AdminNotificationManagement',
    component: NotificationManagement,
  },
  {
    path: '/admin/batch-update',
    name: 'AdminBatchUpdate',
    component: BatchUpdate,
  },
]

export default adminRoutes
